// Copyright (c) 2022 Deere & Company

import PercentageDebit from '../../tcsm/percentage-debit/components';

export default {
    component: PercentageDebit,
    name: 'PERCENTAGE_DEBIT',
    path: 'audits/record/percentage-debit'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/percentage-debit.js